import React from "react";
import { SearchForm } from "./SearchForm";
import { SearchList } from "./SearchList";
import { SnippetSearchResult } from "models";

interface SearchPanelProps{
    searchText: string;
    searchResults: SnippetSearchResult[];
    placeVisisble: boolean;
    onSearchPhraseChange: (text: string) => void;
    onSearchClick: () => void;
    onSearchResultSelected: (id: string) => void;
    onSearchClose: () => void;
    currentSnippetId: string;
    samplesCount: number;
}

export const SearchPanel = ({
    searchText,
    searchResults,
    placeVisisble,
    onSearchPhraseChange,
    onSearchClick,
    onSearchResultSelected,
    onSearchClose,
    currentSnippetId,
    samplesCount
}: SearchPanelProps) => {
    return placeVisisble ?
        <>
            <a
                className="st-search__close-btn mdi mdi-backburger"
                onClick={onSearchClose}
            />
            <span className="st-search--title">Samples</span>
            <SearchForm
                onChange={onSearchPhraseChange}
                searchText={searchText}
            />
            <SearchList
                searchResults={searchResults}
                onSelect={onSearchResultSelected}
                currentSnippetId={currentSnippetId}
            />
        </>
        :
        <div
            className="st-search--collapsed"
            onClick={onSearchClick}
        >
            <a className="mdi mdi-menu" />
            <a className="mdi mdi-magnify"/>
            <span className="st-search--collapsed_title">
                Open more than {samplesCount} examples
            </span>
        </div>;
};
